export default {
  title: 'Support Access',
  username: 'User:',
  password: 'Password:',
  nif: 'NIF:',
  promoterCode: 'Promoter:',
  button: 'Login',
  impersonateUsername: 'Impersonated user',
  selectImpersonateUsername: 'Please, select one impersonated user',
  validate: {
    username: 'User',
    password: 'Password',
    nif: 'Nif',
    appUser: 'User Oauth2',
    appPassword: 'Password Oauth2'
  },
  environment: 'Environment',
  issues: {
    title: 'Technical support',
    subject: 'Subject',
    email: 'Email',
    comments: 'Comments',
    send: 'Send',
    cancel: 'Cancel',
    success: 'The issue has succesfully been reported. The title and case number opened are:',
    getError: 'Service unavailable. Please try again later or contact us at:',
    reportError: 'Sorry. There was a problem reporting the issue. Please try again later or contact us at:',
    validationError: 'Invalid data',
    search: {
      title: 'Search form',
      from: 'From',
      to: 'To',
      number: 'Number',
      status: 'Status'
    },
    headers: {
      created: 'Created',
      number: 'Number',
      subject: 'Subject',
      status: 'Status'
    },
    status: {
      active: 'Active',
      resolved: 'Resolved',
      closed: 'Closed',
      reactivated: 'Reactivated',
      any: 'Any'
    }
  }
}
